import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_FEATURES_AVAILABLE,
  GET_FEATURES_AVAILABLE_SUCCESS,
  GET_CLIENT_CONFIG_SUCCESS,
  SAVE_USER_ROUTES,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  UPDATE_AUTH_USER_DATA,
  SET_2FA_TOKEN,
  VALIDATE_2FA,
  RESEND_2FA_CODE_SUCCESS,
} from "store/auth/login/actionTypes"

const initialState = {
  error: "",
  loading: false,
  featuresAvailable: [],
  clientConfig: {},
  authUser: {},
  vendorId: null,
  userRoutes: [],
  TwoFaToken: null,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_2FA:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        authUser: action.payload.user,
        vendorId: action.payload.vendorId,
      }
      break

    case LOGOUT_USER:
      state = { ...state }
      break

    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break

    case GET_FEATURES_AVAILABLE_SUCCESS:
      state = {
        ...state,
        featuresAvailable: action.payload,
      }
      break
    case GET_CLIENT_CONFIG_SUCCESS:
      state = {
        ...state,
        clientConfig: action.payload
      };
      break
    case SAVE_USER_ROUTES:
      state = {
        ...state,
        userRoutes: action.payload,
      }
      break

    case RESET_PASSWORD:
      state = {
        ...state,
        loading: true,
      }
      break
    case RESET_PASSWORD_SUCCESS:
      state = {
        ...state,
        loading: false,
        // authUser: action.payload.user,
        // vendorId: action.payload.vendorId,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case UPDATE_AUTH_USER_DATA:
      state = {
        ...state,
        authUser: action.payload,
      }
      break
    case SET_2FA_TOKEN:
      state = {
        ...state,
        TwoFaToken: action.payload,
      }
      break
    case RESEND_2FA_CODE_SUCCESS:
      state = {
        ...state,
        TwoFaToken: action.payload,
      }
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
